import { MapContainer, TileLayer, Marker, Popup, useMap } from "react-leaflet";
import "leaflet/dist/leaflet.css";
import L from "leaflet";

// Plugin de pantalla completa
import "leaflet.fullscreen/Control.FullScreen.css";
import "leaflet.fullscreen";

// Fix iconos
import iconUrl from "leaflet/dist/images/marker-icon.png";
import iconShadow from "leaflet/dist/images/marker-shadow.png";
import React from "react";

const DefaultIcon = L.icon({
  iconUrl,
  shadowUrl: iconShadow,
  iconAnchor: [12, 41],
});
L.Marker.prototype.options.icon = DefaultIcon;

interface IMapaVistaProps {
  height?: string;
  latitud: number;
  longitud: number;
  popupText?: string;
}

// Coordenadas por defecto (Bogotá)
const coordendasDefecto: [number, number] = [4.711, -74.0721];

// 🔹 Control de pantalla completa
const FullscreenControl = () => {
  const map = useMap();

  React.useEffect(() => {
    if (!(map as any).fullscreenControl) {
      L.control.fullscreen({
        position: "topleft",
        title: "Pantalla completa",
        titleCancel: "Salir de pantalla completa",
      }).addTo(map);
    }
  }, [map]);

  return null;
};

// 🔹 Componente para centrar y hacer zoom
const RecenterMap = ({
  position,
  zoom,
}: {
  position: [number, number];
  zoom: number;
}) => {
  const map = useMap();

  React.useEffect(() => {
    if (position) {
      map.flyTo(position, zoom, {
        animate: false,
        // duration: 1.5,
      });
    }
  }, [map, position, zoom]);

  return null;
};

// 🔹 Componente para observar cambios de tamaño y actualizar el mapa
const MapResizeObserver = () => {
  const map = useMap();

  React.useEffect(() => {
    if (!map) return;
    
    const observer = new ResizeObserver(() => {
      map.invalidateSize();
    });
    
    observer.observe(map.getContainer());
    
    return () => {
      observer.disconnect();
    };
  }, [map]);

  return null;
};

export const MapaVista: React.FunctionComponent<IMapaVistaProps> = ({
  height = "300px",
  latitud,
  longitud,
  popupText,
}) => {
  // Si llegan 0 o valores inválidos, usar las coordenadas por defecto
  const cooordenadasInvalidas = !latitud || !longitud || (latitud === 0 && longitud === 0);
  const posicion: [number, number] = cooordenadasInvalidas
    ? coordendasDefecto
    : [latitud, longitud];

  // Zoom dinámico
  const zoom = cooordenadasInvalidas ? 12 : 15;

  const finalPopupText = cooordenadasInvalidas
    ? popupText ?? "Ubicación por defecto (Bogotá)"
    : popupText ?? "Ubicación seleccionada";

  return (
    <MapContainer
      center={posicion}
      zoom={zoom}
      style={{ height, width: "100%" }}
    >
      <TileLayer
        attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors &copy; <a href="https://carto.com/attributions">CARTO</a>'
        url={`https://{s}.basemaps.cartocdn.com/rastertiles/voyager/{z}/{x}/{y}{r}.png?key=${import.meta.env.VITE_CARTO_API_KEY}`}
      />

      <Marker position={posicion}>
        <Popup offset={L.point(0, -25)}>{finalPopupText}</Popup>
      </Marker>


      {/* Recentrar automáticamente y hacer zoom */}
      <RecenterMap position={posicion} zoom={zoom} />
      
      {/* Actualizar el mapa cuando cambie de tamaño el contenedor */}
      <MapResizeObserver />

      <FullscreenControl />
    </MapContainer>
  );
};
